import React, {
  Component
} from 'react';

class HomeView extends Component {

  render () {
    return (
      <div>
        <h1>Under Dev!!!</h1>
      </div>
    );
  }

}

export default HomeView;


// WEBPACK FOOTER //
// ./src/components/views/UnderDevView.jsx